// extracted by mini-css-extract-plugin
module.exports = {"start":"idt-align_start__2lee1","end":"idt-align_end__5kzwk","center":"idt-align_center__3mhg3","stretch":"idt-align_stretch__2kcft"};